/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  CatalogItemId,
  CreateServiceRequest,
  GetServiceParams,
  ListServicesParams,
  PaginatedServiceDto,
  ServiceDto,
  UpdateServiceRequest,
} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getListServicesUrl = (params: ListServicesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/engineering/services?${stringifiedParams}`
    : `/api/v1/engineering/services`;
};

/**
 * @summary List services
 */
export const listServices = async (
  params: ListServicesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedServiceDto> => {
  return customFetch<PaginatedServiceDto>(getListServicesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCreateServiceUrl = () => {
  return `/api/v1/engineering/services`;
};

/**
 * @summary Create service
 */
export const createService = async (
  createServiceRequest: CreateServiceRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CatalogItemId> => {
  return customFetch<CatalogItemId>(getCreateServiceUrl(), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(createServiceRequest),
  });
};

export const getGetServiceUrl = (id: CatalogItemId, params?: GetServiceParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/engineering/services/${id}?${stringifiedParams}`
    : `/api/v1/engineering/services/${id}`;
};

/**
 * @summary Get service
 */
export const getService = async (
  id: CatalogItemId,
  params?: GetServiceParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ServiceDto> => {
  return customFetch<ServiceDto>(getGetServiceUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getUpdateServiceUrl = (id: CatalogItemId) => {
  return `/api/v1/engineering/services/${id}`;
};

/**
 * @summary Update service
 */
export const updateService = async (
  id: CatalogItemId,
  updateServiceRequest: UpdateServiceRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getUpdateServiceUrl(id), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(updateServiceRequest),
  });
};

export const getDeleteServiceUrl = (id: CatalogItemId) => {
  return `/api/v1/engineering/services/${id}`;
};

/**
 * @summary Delete service
 */
export const deleteService = async (
  id: CatalogItemId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteServiceUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getRestoreServiceUrl = (id: CatalogItemId) => {
  return `/api/v1/engineering/services/${id}/restore`;
};

/**
 * @summary Restore service
 */
export const restoreService = async (
  id: CatalogItemId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRestoreServiceUrl(id), {
    ...options,
    method: "POST",
  });
};
